// src/features/study/hooks/useArtifactDeleteActions.js
import { useCallback, useState } from "react";

import { apiFetch } from "../../../services/apiClient";

export function useArtifactDeleteActions({ artifactId, onDeleteSuccess }) {
  const [deleteConfirmModal, setDeleteConfirmModal] = useState({
    isOpen: false,
  });

  const openDeleteConfirm = useCallback(() => {
    setDeleteConfirmModal({ isOpen: true });
  }, []);

  const cancelDeleteConfirm = useCallback(() => {
    setDeleteConfirmModal({ isOpen: false });
  }, []);

  const confirmDelete = useCallback(async () => {
    try {
      const response = await apiFetch(`/artifacts/${artifactId}`, {
        method: "DELETE",
      });

      if (response.ok) {
        setDeleteConfirmModal({ isOpen: false });
        onDeleteSuccess?.();
        return { ok: true };
      }

      const error = await response.json().catch(() => ({}));
      alert("삭제 실패: " + (error.error || "알 수 없는 오류"));
      setDeleteConfirmModal({ isOpen: false });
      return { ok: false };
    } catch (err) {
      console.error("삭제 오류:", err);
      alert("삭제 중 오류가 발생했습니다.");
      setDeleteConfirmModal({ isOpen: false });
      return { ok: false };
    }
  }, [artifactId, onDeleteSuccess]);

  return {
    deleteConfirmModal,
    openDeleteConfirm,
    cancelDeleteConfirm,
    confirmDelete,
  };
}
